import { LegalShell } from './PrivacyPage';
import { Link } from 'react-router-dom';

export default function TermsPage() {
  return (
    <LegalShell title="Terms of Service">
      <p className="text-ink-200">
        These terms govern your use of Durak (the "Service"). By signing in or playing, you
        agree to the terms below.
      </p>

      <h2>The Service</h2>
      <p>
        Durak is a free, online multiplayer card game. We provide it on a best-effort basis,
        without warranties or uptime guarantees. Features may change or be removed at any
        time.
      </p>

      <h2>Your account</h2>
      <ul>
        <li>You are responsible for activity that happens under your account.</li>
        <li>You agree not to impersonate other people, abuse, harass, or send unlawful content via in-game chat.</li>
        <li>We may suspend or delete accounts that violate these terms or applicable law.</li>
      </ul>

      <h2>Fair play</h2>
      <ul>
        <li>Do not use bots, scripts, or modified clients to gain an unfair advantage.</li>
        <li>Do not attempt to reverse engineer, probe, or disrupt the Service.</li>
      </ul>

      <h2>User content</h2>
      <p>
        Chat messages and display names you send are transmitted to other players in the
        same room. Don't send anything you wouldn't want others to see.
      </p>

      <h2>Privacy</h2>
      <p>
        Your use of the Service is also governed by our{' '}
        <Link to="/privacy" className="text-accent underline">Privacy Policy</Link>.
      </p>

      <h2>Termination</h2>
      <p>
        You can stop using the Service at any time and request account deletion via the
        email listed in the Privacy Policy. We may terminate access if you breach these
        terms or if we discontinue the Service.
      </p>

      <h2>Disclaimer</h2>
      <p>
        The Service is provided "as is," without warranty of any kind. To the maximum extent
        permitted by law, we are not liable for any indirect, incidental, or consequential
        damages arising from your use of the Service.
      </p>

      <h2>Contact</h2>
      <p>
        Questions? Email{' '}
        <a className="text-accent underline" href="mailto:admin@durak.runnable.dev">admin@durak.runnable.dev</a>.
      </p>

      <p className="text-xs text-ink-300 mt-6">Last updated: 2025-05-23.</p>
    </LegalShell>
  );
}
